/**
 * @file Opens a confirmation modal before an action runs.
 */
import React from "react";
import { ExclamationCircleFilled } from "@ant-design/icons";
import type { ModalFuncProps } from "antd";

const LABEL_YES = "Yes";

type ConfirmModal = {
  confirm: (config: ModalFuncProps) => void;
};

/**
 * Opens an antd confirmation modal and runs `onOk` when the user
 * confirms.
 */
const confirmAction = (
  modal: ConfirmModal,
  okText: ModalFuncProps["okText"],
  title: ModalFuncProps["title"],
  content: ModalFuncProps["content"],
  onOk: ModalFuncProps["onOk"],
  okType?: ModalFuncProps["okType"],
): void => {
  modal.confirm({
    icon: <ExclamationCircleFilled />,
    okText: okText || LABEL_YES,
    okType,
    onOk,
    title,
    content,
    /**
     * Does nothing when the confirmation is dismissed.
     */
    onCancel: () => undefined,
  });
};

export default confirmAction;
